import { useState } from 'react';
import './App.css';
import Home from './components/Home/Home';
import Login from './components/Login/Login';
import { AuthProvider } from './hooks/useAuth';

function App() {

  const [user, setUser] = useState(false)

  return (
    <div className="App">
    {user ? <><Home/></> : <><Login user={user} setUser={setUser}/></>}
      
    </div>
  );
}

export default App;
